import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";
import Calendar from "react-calendar";

import * as navigationActions from "../../../actions/navigationActions";
import * as componentTypes from "../../../constants/componentTypes";
import * as filteringTypes from "../../../constants/filtering";
import * as actions from "../../../actions/filteringActions";
import * as modelHelper from "../../../helpers/modelHelper";

import imgConfirm from "../../../resources/img/svgicons/confirm.svg";
import Modal from "../generic/Modal";
import Button from "../generic/Button";
import CancelButton from "../generic/CancelButton";

class DatePickerModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newDateTo: this.props.to,
            newDateFrom: this.props.from
        };
    }
    changeDate = (date) => {
        let newDate;
        if (this.props.params === "from") {
            newDate = new Date(date.setHours(0, 0, 0));
            this.setState({newDateFrom: newDate});
        }
        if (this.props.params === "to") {
            newDate = new Date(date.setHours(23, 59, 59));
            this.setState({newDateTo: newDate});
        }
    };

    getDatePicker = () => {
        let today = new Date();
        let minDay = new Date(1970, 0, 1);

        if (this.props.params === "from") {
            return (
                <Calendar
                    onClickDay={(date) => {
                        this.changeDate(date);
                    }}
                    maxDate={this.props.to === null ? today : this.props.to}
                    minDate={minDay}
                    value={this.state.newDateFrom === null ? today : this.state.newDateFrom}
                    locale={this.props.language}
                    minDetail="year"
                />
            );
        }

        if (this.props.params === "to") {
            return (
                <Calendar
                    onClickDay={(date) => {
                        this.changeDate(date);
                    }}
                    maxDate={today}
                    minDate={this.props.from === null ? minDay : this.props.from}
                    value={this.state.newDateTo === null ? today : this.state.newDateTo}
                    locale={this.props.language}
                    minDetail="year"
                />
            );
        }

        return "";
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseDatePickerModalAction();
    };

    handleConfirmButtonClick = () => {
        if (this.props.params === "to") {
            this.props.dispatchChangeDateToAction(this.props.tabId, this.state.newDateTo);
        }
        if (this.props.params === "from") {
            this.props.dispatchChangeDateFromAction(this.props.tabId, this.state.newDateFrom);
        }
        this.props.dispatchCloseDatePickerModalAction();
    };

    getModalTitle = () => {
        if (this.props.params === "from") {
            return <Translate value="filtering.from" />;
        }

        return <Translate value="filtering.to" />;
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    label={<Translate value="general.confirm" />}
                    svgBefore={imgConfirm}
                    onClick={this.handleConfirmButtonClick}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(this.getModalTitle())}
                content={modelHelper.buildModalSection(this.getDatePicker(), "slim-scroll")}
                footer={this.getFooter()}
                styles={{minWidth: "50%"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (ownProps.tabId === undefined || store.filtering[ownProps.tabId] === undefined) {
        return {
            from: null,
            to: null,
            language: store.settings.locale
        };
    }

    return {
        from: store.filtering[ownProps.tabId].dateFrom,
        to: store.filtering[ownProps.tabId].dateTo,
        language: store.settings.locale
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseDatePickerModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.DATE_PICKER_MODAL));
        },
        dispatchChangeDateFromAction: (tabId, from) => {
            dispatch(actions.changeFilterParams(tabId, filteringTypes.DATE_FROM, from));
        },
        dispatchChangeDateToAction: (tabId, to) => {
            dispatch(actions.changeFilterParams(tabId, filteringTypes.DATE_TO, to));
        }
    };
};

export default DatePickerModal = connect(mapStoreToProps, mapDispatchToProps)(DatePickerModal);
